import { equipmentFieldNameDictionary } from '@models/FieldConfiguration.model';
import { trackAssetsEdited } from '@services/mixpanel/trackers/AssetMetrics';
import { isNonNullable } from '@utils/isNonNullable';
import { IFormDataOnboardingModal } from '../OnBoardingModal';
import { EquipmentTypeKeepNulls } from '../types';
import { MassEditShared } from './PatchMassEditLambda';
// Extend mass field names

const equipmentMassEditDictionary = {
  ...equipmentFieldNameDictionary,
  tagsId: equipmentFieldNameDictionary.tags,
  productId: 'Product',
  userId: equipmentFieldNameDictionary.userName,
  equipmentStatusId: equipmentFieldNameDictionary.equipmentStatusName,
  id: null,
  studioId: null,
  extendedWarrantyPurchased: 'Extended Warranty Purchased',
  extendedWarrantyLength: 'Extended Warranty Length',
  customFields: 'Custom Fields',
};

export async function doTrackAssetBulkEdit(
  dirtyEqs: IFormDataOnboardingModal['dirtyFields']['equipments'],
  variables: MassEditShared,
) {
  if (dirtyEqs) {
    let parameters: string[] = [];
    const params = dirtyEqs.map(async dirtyEq => {
      parameters = parameters.concat(Object.keys(dirtyEq));
    });
    await Promise.all(params);
    const ids = variables.params.map(equipment => equipment.id);
    const asSet = new Set(parameters);
    // Map to a readable name
    const unset = Array.from(asSet, value => {
      // Rename some fields
      const fullTypedValue = value as keyof EquipmentTypeKeepNulls;
      const mappedValue = equipmentMassEditDictionary[fullTypedValue];
      return mappedValue;
    });
    // Exclude id
    const filtered = unset.filter(isNonNullable);

    trackAssetsEdited(filtered, ids);
  }
}
